var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// elements/components/x-loading-state.ts
import { html } from "lit";
import { customElement, property } from "lit/decorators.js";
import { ChemistryLitElement } from "../../chemistry-lit-element";
import "./x-empty-placeholder";
import "./x-loader";
var ElementsLoadingState = class extends ChemistryLitElement {
  constructor() {
    super(...arguments);
    this["no-wrapper"] = false;
    this.text = "";
  }
  render() {
    return html`
      <x-empty-placeholder
        .img="${html` <x-loader></x-loader> `}"
        .text="${this.text}"
        ?no-wrapper="${this["no-wrapper"]}"
      ></x-empty-placeholder>
    `;
  }
};
__decorateClass([
  property({ type: Boolean })
], ElementsLoadingState.prototype, "no-wrapper", 2);
__decorateClass([
  property()
], ElementsLoadingState.prototype, "text", 2);
ElementsLoadingState = __decorateClass([
  customElement("x-loading-state")
], ElementsLoadingState);
export {
  ElementsLoadingState
};
